import type { ThemeConfig } from 'antd';

// Theme COFASA: paleta corporativa. Ajustar colores cuando lleguen los del cliente.
export const cofasaTheme: ThemeConfig = {
  token: {
    colorPrimary: '#003d7a',     // azul corporativo
    colorSuccess: '#28a745',
    colorWarning: '#ffc107',
    colorError: '#dc3545',
    borderRadius: 6,
    fontFamily:
      "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif",
  },
  components: {
    Button: {
      controlHeight: 44,
      fontSize: 16,
      fontWeight: 600,
    },
    Input: {
      controlHeight: 44,
    },
    Form: {
      itemMarginBottom: 20,
    },
  },
};
